import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/api/api.service";
import {Observable} from "rxjs";
import {CreateCardDto, SavedCardListDto} from "../models/saved-card.models";
import {UserInfoService} from "../../../services/user-info.service";

@Injectable({
  providedIn: 'root'
})
export class CardDataService {

  agentId: string | undefined
  userId: number | undefined

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {

    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res
      }
    })

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res
      }
    })
  }

  loadActiveCardList(): Observable<SavedCardListDto> {
    const url = `/agents/${this.agentId}/saved_cards?page_number=0&per_page=20&is_blocked=false`
    return this.apiService.httpGet<SavedCardListDto>(url)
  }

  loadBlockedCardList(): Observable<SavedCardListDto> {
    const url = `/agents/${this.agentId}/saved_cards?page_number=0&per_page=20&is_blocked=true`
    return this.apiService.httpGet<SavedCardListDto>(url)
  }

  makeMainCard(id: string): Observable<void> {
    const url = `/agents/${this.agentId}/saved_cards/${id}/main?isMain=true`
    return this.apiService.httpPatch<void>(url)
  }

  activatedCard(id: string): Observable<void> {
    const url = `/agents/${this.agentId}/saved_cards/${id}/blocked?isBlocked=false`
    return this.apiService.httpPatch<void>(url)
  }

  blockedCard(id: string): Observable<void> {
    const url = `/agents/${this.agentId}/saved_cards/${id}/blocked?isBlocked=true`
    return this.apiService.httpPatch<void>(url)
  }

  addCard(body: CreateCardDto): Observable<void> {
    const url = `/agents/${this.agentId}/cards`
    return this.apiService.httpPost<void>(url, body)
  }

  deleteCard(id: string): Observable<void> {
    const url = `/agents/${this.agentId}/saved_cards/${id}`
    return this.apiService.httpDelete<void>(url)
  }
}
